export default __webpack_public_path__ + "static/media/drip.f4d96a2e.mp3";